const currencyStyle = (lang, symbol, total) => {
  if (lang === 'fr') return total + symbol;
  else return symbol + total;
};

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const zeroPad = (num, places) => String(num).padStart(places, '0');

function rearrangeBasedOnFirstArray(firstArray, secondArray) {
  // If the first array is empty, return the second array as it is
  if (firstArray.length === 0) {
    return secondArray;
  }

  // If the second array is empty, return an empty array
  if (secondArray.length === 0) {
    return [];
  }

  // Create a map for quick lookup of the index of each element in the first array based on the '_id' attribute
  let indexMap = new Map();
  firstArray.forEach((element, index) => indexMap.set(element, index));

  // Separate the elements of the second array into matched and extra
  let matchedElements = [];
  let extraElements = [];

  secondArray.forEach((element, index) => {
    if (indexMap.has(element._id)) {
      matchedElements.push(element);
    } else {
      extraElements.push(element);
    }
  });

  // Sort the matched elements based on the order in the first array
  matchedElements.sort((a, b) => indexMap.get(a._id) - indexMap.get(b._id));
  let fincalArray = matchedElements.concat(extraElements);
  //change idx to index of the sorted array
  fincalArray.forEach((element, index) => (element.idx = index));

  // Concatenate the sorted matched elements with the extra elements

  return fincalArray;
}

module.exports = {
  currencyStyle,
  sleep,
  zeroPad,
  rearrangeBasedOnFirstArray,
};
